import { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight, ArrowLeft, Lock } from "lucide-react";
import Logo from "@/components/Logo";
import { setToken } from "@/lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      setToken(data.access_token);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full bg-transparent border-0 border-b border-[#F7F2E9]/25 rounded-none py-3 font-body text-[#F7F2E9] placeholder:text-[#F7F2E9]/40 focus:outline-none focus:border-konattu-red transition-colors";

  return (
    <div className="min-h-screen bg-konattu-charcoal flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="noise-overlay" />
      <div className="w-full max-w-md relative z-10">
        <Link to="/" className="inline-flex items-center gap-2 font-mono text-xs tracking-[0.25em] text-konattu-yellow mb-10" data-testid="login-back">
          <ArrowLeft size={14} /> BACK TO SITE
        </Link>
        <div className="mb-8"><Logo /></div>
        <div className="flex items-center gap-2 mb-2">
          <Lock size={16} className="text-konattu-red" />
          <span className="font-mono text-xs tracking-[0.3em] text-konattu-red">ADMIN ACCESS</span>
        </div>
        <h1 className="font-display font-bold text-4xl text-[#F7F2E9] tracking-tight mb-10">Sign in to the panel.</h1>
        <form onSubmit={submit} className="space-y-8" data-testid="admin-login-form">
          <input data-testid="login-email" type="email" className={inputCls} placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <input data-testid="login-password" type="password" className={inputCls} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          <button type="submit" disabled={loading} data-testid="login-submit" className="group inline-flex items-center gap-3 bg-konattu-red text-white px-8 py-4 text-sm font-medium tracking-wide hover:bg-konattu-orange transition-colors disabled:opacity-60 w-full justify-center">
            {loading ? "Signing in..." : "Sign in"}
            <ArrowRight size={17} className="group-hover:translate-x-1 transition-transform" />
          </button>
        </form>
      </div>
    </div>
  );
}
